import "./LeadGeneration.module.css";
import Header from "@/reusable_sections/Header";
import OurServices from "./sections/OurServices";
import RequestAQuote from "./sections/RequestAQuote";
import InquiryForm from "./sections/InquiryForm";
import Footer from "@/reusable_sections/Footer";
import TheCommandCenter from "./sections/TheCommandCenter";
export default function LeadGenerationPage() {
  return <div>
      <Header />
      <OurServices />
      <TheCommandCenter />
      <RequestAQuote />
      <InquiryForm />
      <Footer />
    </div>;
}